import { type StripeConstructorOptions } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

let stripePromise;
export const getStripe = async (chargeType, stripeAccount) => {
  if (!stripePromise) {
    const options: StripeConstructorOptions = {};

    if (chargeType === 'DirectCharge') {
      options.stripeAccount = stripeAccount;
    }

    await sleep(process.env.NEXT_PUBLIC_STRIPE_DELAY || 0);
    stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY, options);
    console.log(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY, chargeType, stripeAccount);
  }

  return stripePromise;
};

const collectionsUsingStripe = ['FunnelCart'];
export function needsStripeContext(pageData) {
  return pageData.sections.some(section => {
    if (collectionsUsingStripe.includes(section.collection)) {
      return true;
    }

    if (section.collection === 'TwoColumn') {
      if (section.item.rightColumn.some(el => collectionsUsingStripe.includes(el.collection))) {
        return true;
      }
    }

    return false;
  });
}
